// extracted by mini-css-extract-plugin
export default {"feedbackHeader":"feedbackHeader__n1qKv","feedbackHeaderContent":"feedbackHeaderContent__p8NTp","feedbackItem":"feedbackItem__Hx1MF"};